/* Jeśli w jakimś projekcie zrezygnujemy z icubejs to możemy zmienić przestrzeń nazw dla pluginów w tym miejscu */
window.installICubePlugin = function(factory) {
    'use strict';
    window.ICube = window.ICube || {};
    window.ICube.plugins = window.ICube.plugins || {};
    factory(window.ICube.plugins);
}